/* eslint-disable import/no-extraneous-dependencies */
import { z } from 'zod';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SchemaEnvironment } from '../../../schema/environment';

export type EnvironmentState = z.infer<typeof SchemaEnvironment>;

const slice = createSlice({
  name: 'environmentState',
  initialState: {} as EnvironmentState,
  reducers: {
    setEnvironment: (state, action: PayloadAction<EnvironmentState>) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { setEnvironment } = slice.actions;

export default slice.reducer;
